<template>
  <div 
    class="banner" 
    :style="style" 
    :aria-label="ariaLabel" 
    role="image"
  ><slot/></div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    image: {
      type: String,
      required: true
    },
    ariaLabel: {
      type: String,
      default: ""
    },
    minHeight: {
      type: Number,
      default: 420
    },
  },
  computed: {
    style() {
      return {
        paddingTop: '90px',
        borderBox: 'box-sizing',
        backgroundImage: `url(${this.image})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: `${this.minHeight}px`,
      }
    }
  }
}
</script>
